module.exports = __webpack_public_path__ + "img/ico-swiper-btn-prev.3619e821.svg";